<div *ngIf="!alertClosed" [ngClass]="'sdps-messaging sdps-messaging--' + [type]" data-testid="bannersComponent_banner">
  <sdps-icon [ngClass]="useBulletedListDisplay ? 'sdps-bulleted-list' : 'sdps-messaging__icon'" id="banner-icon" color="{{type}}" data-testid="bannersComponent_icon" type="functional" [name]="iconName()" size="small"></sdps-icon>
  <div *ngIf="type === 'information' && showCloseIcon" class="close-icon sch-thin-x no-print" (click)="onClose()"
    data-testid="bannersComponent_closeButton"></div>
  <div class="sdps-messaging__text" data-testid="bannersComponent_textSection">
    <div *ngIf="titleText && !shouldBoldTitleText" data-testid="bannersComponent_titleText">
      <span [ngClass]="shouldBoldTitleText ? 'strong' : ''" [innerText]="titleText"></span>
    </div>
    <div *ngIf="titleText && shouldBoldTitleText" data-testid="bannersComponent_titleText">
      <strong [innerText]="titleText"></strong>
    </div>
    <div *ngIf="useBulletedListDisplay; then multipleLines else singleLine"></div>
    <ng-template #multipleLines>
      <sdps-list type="bullet" aria-label="bullet">
          <sdps-list-item *ngFor="let line of bannerText; index as i" class="sdps-list-item__item">{{line}}</sdps-list-item>
      </sdps-list>
    </ng-template>
    <ng-template #singleLine>
      <span *ngFor="let line of bannerText" [innerText]="line" [class.inline]="boldText"></span>
    </ng-template>
    <span *ngFor="let line of htmlStr" [innerHTML]="line"></span>
    <span *ngIf="hyperlink">
      <a (click)="redirect()">{{hyperlink.text}}</a>
    </span>
    <span *ngIf="routeRedirect">
      <a (click)="redirectRoute()">{{routeRedirect.text}}</a>
    </span>
    <strong *ngIf="boldText">{{boldText}}</strong>
    <span *ngIf="achRedirect"> for client authorization.</span>
    <span *ngIf="verifyAttentionMessage">
      <strong>Important information about this transaction:</strong>
      <ul>
        <li *ngFor="let warning of warningMessages; index as i">
          {{i + 1}}. {{warning}}
        </li><!--
           -->
        <li *ngIf="charitableMessage"> {{warningMessages.size + 1}}. Any transfer of securities or cash to a Donor-Advised Fund (DAF) account is an irrevocable transfer of ownership to Donor Advised Charitable Giving, Inc.
          (“DAFgiving360”) and is not refundable for any reason.</li>

        <li *ngIf="stateTaxAttentionRequiredMI && stateCode === 'MI'"> {{warningMessages.size + 1}}. Your client's
          state of residency (Michigan) requires a new W4P form if
          state tax withholding is changed to 0%. Visit <a target="_blank"
            href='https://www.michigan.gov/taxes'>michigan.gov/taxes </a>
          to download the form or contact the state tax authority for information.</li>

        <li *ngIf="stateTaxAttentionRequiredCT && stateCode === 'CT'"> {{warningMessages.size + 1}}. Your client's
          state of residency (Connecticut) requires a new W4P form if
          state tax withholding is changed to 0%. Visit <a target="_blank"
            href='https://portal.ct.gov/drs'>portal.ct.gov/drs </a>
          to download the form or contact the state tax authority for information.</li>

        <li *ngIf="stateTaxAttentionRequiredMN && stateCode === 'MN'"> {{warningMessages.size + 1}}. Your client's
          state of residency (Minnesota) requires a new WMNP form if
          state tax withholding is changed to 0%. Visit <a target="_blank"
            href='https://www.revenue.state.mn.us/form-search'>www.revenue.state.mn.us/form-search </a>
          to download the form or contact the state tax authority for information.</li>

        <li *ngIf="RothSimpleTaxAttentionRequired"> {{warningMessages.size + 1}}. Requested Distribution code no longer valid - 
          Distribution Code and Tax Withholding have been updated</li>
      </ul>
    </span>
    <span *ngIf="downloadCheckJournalRequestForm">
          <span *ngIf="isIra; else nonIraFormDrupal" data-testid="iraRequestFormError">This type of account is not eligible for
          online transfers. Please <a
          (click)="getDrupalPdf('IRA-distribution-form')" id="fna-download-1">download
          a request form</a> to be submitted through Docusign.</span>
          <ng-template #nonIraFormDrupal>
            <span data-testid="nonIraRequestFormError">This type of account is not eligible for online transfers. Please <a
              (click)="getDrupalPdf('check-and-journal-request-form')" id="fna-download-1">download
              a request form</a> to be submitted through Docusign.</span>
          </ng-template>
   </span>
   <span *ngIf="positionsLotFailure">
      A technical issue is preventing this receiving account from being loaded in the Positions table. You can remove it from the transaction and continue, or try canceling and starting a new transaction.
   </span>
   <div *ngIf="nonIsoAddressFooter">
    <span>
      <strong>Address on file: </strong>{{nonIsoAddressFooter}}
     </span>
   </div>
  </div>
</div>
